/* eslint-disable */
import { PluginContainerData, Link } from './common';
const baseLinkPreviewData = {};
export const LinkPreviewData = {
    fromJSON(object) {
        const message = Object.assign({}, baseLinkPreviewData);
        message.containerData =
            object.containerData !== undefined && object.containerData !== null
                ? PluginContainerData.fromJSON(object.containerData)
                : undefined;
        message.link =
            object.link !== undefined && object.link !== null ? Link.fromJSON(object.link) : undefined;
        message.title =
            object.title !== undefined && object.title !== null ? String(object.title) : undefined;
        message.thumbnailUrl =
            object.thumbnailUrl !== undefined && object.thumbnailUrl !== null
                ? String(object.thumbnailUrl)
                : undefined;
        message.description =
            object.description !== undefined && object.description !== null
                ? String(object.description)
                : undefined;
        message.html =
            object.html !== undefined && object.html !== null ? String(object.html) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.containerData !== undefined &&
            (obj.containerData = message.containerData
                ? PluginContainerData.toJSON(message.containerData)
                : undefined);
        message.link !== undefined && (obj.link = message.link ? Link.toJSON(message.link) : undefined);
        message.title !== undefined && (obj.title = message.title);
        message.thumbnailUrl !== undefined && (obj.thumbnailUrl = message.thumbnailUrl);
        message.description !== undefined && (obj.description = message.description);
        message.html !== undefined && (obj.html = message.html);
        return obj;
    },
};
//# sourceMappingURL=plugin_link_preview.js.map